<template>
  <div class="locations-and-states">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>States</h1></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="2-2"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-select @change="selectPage(1)" style="max-width: 200px" placeholder="Select Country"  class="mr-1" v-model="listParam.CountryID" filterable  clearable>
                <el-option v-for="item in countryList" :key="item.CountryID" :value="item.CountryID"
                           :label="decodeURI(item.CountryName)"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:20%" class="long-text">State Name</th>
                  <th style="width:10%" class="long-text">State Code</th>
                  <th style="width:35%" class="long-text">State Description</th>
                  <th style="width:20%" class="long-text">Country</th>
                  <th style="width:15%;vertical-align:middle" class="icon-col">
                    <div v-if="user.type >= 6" class="icon-group justify-content-center align-items-center">
                      <v-btn class="add-icon" @click="dialogVisible = true" dark>Add New</v-btn>
                    </div>
                  </th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="locations.length > 5 ? 'content-scroll-y' : ''"> -->
            <div>
              <table class="table">
                <tbody>
                <tr v-for="state in states" :key="state.StateID">
                  <td style="width:20%" class="long-text">{{ decodeURI(state.StateName) }}</td>
                  <td style="width:10%" class="long-text">{{ state.StateCode }}</td>
                  <td style="width:35%" class="long-text">{{ state.StateDescription }}</td>
                  <td style="width:20%" class="long-text">{{ decodeURI(state.CountryName) }}</td>
                  <td style="width:15%; vertical-align:middle" class="icon-col">
                    <div class="icon-group justify-content-center align-items-center">
                      <img @click="currentObj=$_.cloneDeep(state); dialogVisible=true" data-toggle="tooltip" data-placement="right"
                           title="Edit State" src="@/assets/images/edit_icon.svg"/>
                      <img v-if="user.type>= 6" data-toggle="tooltip" data-placement="right"
                           title="Delete State" @click="showDelete(state)" src="@/assets/images/delete_icon.svg"/>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
    <el-dialog
        class="edit-zoho-dialog"
        :title="currentObj.StateID ? 'Edit State' : 'Add State'"
        :visible.sync="dialogVisible"
        @close="closeModal"
        width="50%">
      <div>
        <el-form ref="ruleForm" :model="currentObj" label-width="180px" :rules="rules">
          <el-form-item label="State Name" prop="StateName">
            <el-input placeholder="State Name" v-model="currentObj.StateName" maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="State Code" prop="StateCode">
            <el-input placeholder="State Code" v-model="currentObj.StateCode" maxlength="3"></el-input>
          </el-form-item>
          <el-form-item label="Country" prop="CountryID">
            <el-select class="w-100" v-model="currentObj.CountryID" filterable clearable placeholder="Select Country"
                       :loading="loadingSelect">
              <el-option v-for="item in countryList" :key="item.CountryID" :value="item.CountryID"
                         :label="decodeURI(item.CountryName)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="State Description" prop="StateDescription">
            <el-input type="textarea" v-model="currentObj.StateDescription" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="dialogVisible = false">Cancel</v-btn>
    <v-btn :disabled="user.type < 6" dark :loading="loading" @click="submitForm('ruleForm')">Save</v-btn>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'

export default {
  name: 'AdminLocationsAndRegions',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    const stateNameValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('State Name is required.'))
        return
      }
      if (s.length > 32) {
        callback(new Error('State Name must not exceed 32 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('State Name must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s-]+$/.test(s)) {
        callback(new Error('State Name may only contain English letters, spaces, and hyphens (-).'))
        return
      }
      callback()
    }
    const stateCodeValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback(new Error('State Code is required.'))
        return
      }
      if (s.length > 3) {
        callback(new Error('State Code must not exceed 3 characters.'))
        return
      }
      if (!/^[A-Za-z]+$/.test(s)) {
        callback(new Error('State Code may only contain English letters (A-Z, a-z).'))
        return
      }
      callback()
    }
    const stateDescriptionValidator = (rule, value, callback) => {
      const s = String(value || '').trim()
      if (!s) {
        callback()
        return
      }
      if (s.length > 100) {
        callback(new Error('State Description must not exceed 100 characters.'))
        return
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        callback(new Error('State Description must include at least one English letter.'))
        return
      }
      if (!/^[A-Za-z\s\-()&]+$/.test(s)) {
        callback(new Error('State Description may only contain English letters, spaces, hyphens (-), parentheses ( ), and ampersand (&).'))
        return
      }
      callback()
    }
    return {
      currentObj: {
        StateName: '',
        StateCode: '',
        StateDescription: '',
        CountryID: null,
      },
      loadingSelect: false,
      countryList: [],
      rules: {
        StateName: [
          {validator: stateNameValidator, trigger: ['blur', 'change']},
        ],
        StateCode: [
          {validator: stateCodeValidator, trigger: ['blur', 'change']},
        ],
        CountryID: [
          {required: true, message: 'Please select country', trigger: 'change'},
        ],
        StateDescription: [
          {validator: stateDescriptionValidator, trigger: ['blur', 'change']},
        ],
      },
      loading: false,
      states: [],
      dialogVisible: false,
      totalCount: 0,
      listParam: {
        pageNum: 1,
        pageSize: 10,
        CountryID: ''
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    closeModal() {
      this.$refs.ruleForm.resetFields()
      this.currentObj = {
        StateName: '',
        StateCode: '',
        StateDescription: '',
        CountryID: null,
      }
    },
    showDelete(c) {
      this.$confirm({
        content: `Are you sure you wish to delete the state: ${c.StateName}?`,
        onConfirm: () => {
          utilities.deleteState(c.StateID).then(() => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: '<div class="alert-success">' +
                  '            <b>Success:</b> State Deleted !' +
                  '          </div>',
            });
            this.selectPage(1)
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.currentObj.StateName = String(this.currentObj.StateName || '').trim()
          this.currentObj.StateCode = String(this.currentObj.StateCode || '').trim()
          this.currentObj.StateDescription = String(this.currentObj.StateDescription || '').trim()
          this.loading = true
          if (this.currentObj.StateID) {
            const id = this.currentObj.StateID
            const obj = {...this.currentObj}
            delete obj.StateID
            delete obj.StateName
            delete obj.CountryName
            delete obj.CountryCode
            if(!obj.StateDescription) {
              delete obj.StateDescription
            }
            utilities.putState(id, obj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> State Updated !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          } else {
            utilities.postState(this.currentObj).then(() => {
              this.loading = false
              this.dialogVisible = false
              this.$notify({
                dangerouslyUseHTMLString: true,
                message: '<div class="alert-success">' +
                    '            <b>Success:</b> State Created !' +
                    '          </div>',
              });
              this.selectPage(1)
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          return false;
        }
      });
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.getData()
    },
    async getData() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      const {data, count} = await utilities.getStatesNew(this.listParam)
      this.states = data
      this.totalCount = count
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  async beforeMount() {
    await this.getData()
    const {data} = await utilities.getCountries({pageNum: 1, pageSize: 999,})
    this.countryList = data
  },
  mounted() {
  },
}
</script>
